import useCompanyState from '@/states/company.state';
import useTenantState from '@/states/tenant.state';
import { useCompanyProfile } from '@/hooks/useCompanyProfile';
import { BusinessGoalSkeleton } from '@/components/company/skeletons';
import { useCompanyProfileSteps } from '@/hooks/useCompanyProfileSteps';
import BusinessGoalKinerja from './business-goal/BusinessGoalKinerja';

export default function BusinessGoal() {
  const { currentTenant } = useTenantState();
  const { isLoading } = useCompanyProfile(currentTenant?.id);

  useCompanyProfileSteps();
  const { companyProfileSteps } = useCompanyState();
  const businessgoalStep = companyProfileSteps.find(step =>
    ['business goal', 'business goals'].includes(step.step_name.trim().toLowerCase()),
  );

  if (isLoading) {
    return <BusinessGoalSkeleton />;
  }

  return <BusinessGoalKinerja videoLink={businessgoalStep?.video_link} tips={businessgoalStep?.tips} />;
}
